import {FEATURE_FLAGS} from '../../../constants';
import {hasFeatureFlag} from './FeatureUtil';
import Util from './util';

type MaybeOpportunity = {id?: string | null; profile?: string | null};

/** Whether Opportunity stages are shown: with custom stages on, or with Opportunity access. */
export const showsOpportunityStages = (): boolean =>
	hasFeatureFlag(FEATURE_FLAGS.CUSTOM_PROJECT_STAGES) || Util.hasOpportunityAccess();

/**
 * The stages to show. Opportunity stages are dropped unless the rule allows them or the stage is one to keep (e.g. the
 * stage of the project being viewed). The input order is kept.
 */
export const visibleStages = <S extends MaybeOpportunity>(
	stages: ReadonlyArray<S>,
	keepStageIds: ReadonlyArray<string> = [],
	showOpportunity: boolean = showsOpportunityStages()
): S[] =>
	stages.filter(
		stage => stage.profile !== 'OPPORTUNITY' || showOpportunity || (!!stage.id && keepStageIds.includes(stage.id))
	);
